export function GetMockMilestoneRead() {
  return {
    id: 1,
    milestoneTypeId: 18,
    caseId: 1,
    updatedByUserId: 4,
    dateUpdated: "2022-05-12T10:32:22.0598484",
    milestoneDate: "0001-01-01T00:00:00",
    milestoneData:
      '{"qualificationStatus":1,"qualifiedDate":"2022-02-01T00:00:00.000Z","caseProceedable":0,"caseProceedableYesWhy":"Proceeding with JMNB","sharedOwnershipPurchase":0,"isHTB":0,"standardPurchase":1,"qualifiedReserve":0,"isMilestoneComplete":1,"caseProceedableNoWhy":"Proceeding via own means"}',
    sendEmail: 1,
    updateCaseStatus: 1,
    offerExpiryDate: "0001-01-01T00:00:00",
  };
}
